import { Navigate } from 'react-router-dom';
import RoleBasedGuard from '../../../guards/RoleBasedGuard';
import AuthGuardLayout from '../../../components/layouts/AuthGuardLayout';

import { HISTORY_PATH } from './historyPath';
import { orderRoute } from '../order/routes';
import { deliveryRoute } from '../delivery/routes';
import { shippingScheduleRoute } from '../shipping-schedule/routes';


export const historyRoute = {
  path: 'history',
  element: <AuthGuardLayout />,
  children: [
    {
      path: '',
      element: <Navigate to={HISTORY_PATH.ORDER} replace />,
    },
    orderRoute,
    deliveryRoute,
    shippingScheduleRoute,
  ],
};
